/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.19.0
 */

import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import omit from 'lodash/omit';
import pickBy from 'lodash/pickBy';

export const clearTableMetaFilters = (filter: { [name: string]: any }, availableNames?: string[]) =>
    pickBy(filter, (value, key) =>
        !!value
        // если значение объект, то проверить, что поля не null
        && (!isObject(value) || !!Object.keys(pickBy(omit(value, 'valueForLike'), v => v !== '' && !isNil(v))).length)
        && (!availableNames || availableNames.includes(key)));
